<div class="dashboard">
  <div class="row gx-2" *ngIf="!isLoading; else skeletonLoaderStatus">
    <div class="col-md-2">
      <mat-card class="statusBox">
        <mat-card-content>
          <!-- <span class="big-icon purpleBg"><img src="../../../../assets/img/icons/Dashbord KPI/Initiated.svg" /></span> -->
          <span class="big-font textorange">{{
            totalInitiatedContractCount
            }}</span>
          <a href="javascript:void(0)" class="gray-txt" (click)="getContractsCommanly(0)">Contract Initiated By Me
          </a>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-md-2">
      <mat-card class="statusBox">
        <mat-card-content>
          <span class="big-font textorange">{{
            totalPendingSignatureContractCount
            }}</span>
          <a href="javascript:void(0)" class="gray-txt" (click)="getContractsCommanly(1)">Pending Signature
          </a>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-md-2">
      <mat-card class="statusBox">
        <mat-card-content>
          <!-- <span class="big-icon"><img src="../../../../assets/img/icons/Dashbord KPI/Pending for review.svg" /></span> -->
          <span class="big-font textorange" >{{
            totalPendingReviewCount
            }}</span>
          <a href="javascript:void(0)" class="gray-txt" (click)="getContractsCommanly(2)">Pending My Review</a>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-md-2">
      <mat-card class="statusBox">
        <mat-card-content>
          <!-- <span class="big-icon"><img src="../../../../assets/img/icons/Dashbord KPI/Pending Approval.svg" /></span> -->
          <span class="big-font textorange">{{
            totalPendingContractCount
            }}</span>
          <a href="javascript:void(0)" class="gray-txt" (click)="getContractsCommanly(3)">Pending My
            Approval</a>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-md-2">
      <mat-card class="statusBox">
        <mat-card-content>
          <!-- <span class="big-icon pinkBg"><img style="border-radius: 50%;" 
              src="../../../../assets/img/icons/Dashbord KPI/icons8-expire-100 (1).png" /></span>-->
          <span class="big-font textorange">{{
            totalExpireCount
            }}</span>
          <a href="javascript:void(0)" class="gray-txt" (click)="getContractsCommanly(4)">Expiring in 30 Days
          </a>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-md-2">
      <mat-card class="statusBox">
        <mat-card-content>
          <!-- <span class="big-icon purpleBg"><img
              src="../../../../assets/img/icons/Dashbord KPI/icons8-expired-64 (2).png" /></span> -->
          <span class="big-font textorange">{{
            totalExpiredCount }}</span>
          <a href="javascript:void(0)" class="gray-txt" (click)="getContractsCommanly(5)">Expired in last 90
            Days
          </a>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-md-2">
      <mat-card class="statusBox">
        <mat-card-content>
          <!-- <span class="big-icon"><img style="border-radius: 50%;"
              src="../../../../assets/img/icons/Dashbord KPI/icons8-finance-64.png" /></span> -->
          <span class=" textorange big-font"> ${{
            totalWorth
            }}</span>
          <a href="javascript:void(0)" class="gray-txt" (click)="getContractsCommanly(6)">Contracts Worth expiring
            in 30 Days
          </a>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-md-2">
      <mat-card class="statusBox">
        <mat-card-content>
          <!-- <span class="big-icon "><img class="img"
              src="../../../../assets/img/icons/Dashbord KPI/icons8-dollar-coin-64.png" /></span> -->
          <span class="textorange big-font"> ${{
            totalAmount
            }}</span>
          <a class="gray-txt" href="javascript:void(0)" (click)="getContractsCommanly(7)">Contract Worth
            pending Signature
          </a>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-md-2">
      <mat-card class="statusBox">
        <mat-card-content>
          <!-- <span class="big-icon pinkBg"><img
              src="../../../../assets/img/icons/Dashbord KPI/icons8-general-mandatory-action-100 (1).png" /></span> -->
          <span class="big-font textorange">{{
            totalExpireCount
            }}</span>
          <a href="javascript:void(0)" class="gray-txt" (click)="getContractsCommanly(7)">Obligation Overdue
          </a>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-md-2" *ngFor="let kpi of kpiData">
      <mat-card class="statusBox">
        <mat-card-content>
          <span class="big-font textorange">{{ kpi.count }}</span>
          <a href="javascript:void(0)" class="gray-txt" (click)="getContractsCommanly(8)">{{ kpi.kpiName }}</a>
        </mat-card-content>
      </mat-card>
    </div>
    

  </div>
  <ng-template #skeletonLoaderStatus>
    <div class="row gx-2">
      <div class="col-md-2" *ngFor="let _ of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];">
        <div class="statusBox">
          <ngx-skeleton-loader [theme]="{height:'100px'}"></ngx-skeleton-loader>
        </div>
      </div>
    </div>
  </ng-template>



  <div class="task-graph">
    <div class="row" *ngIf="!isLoading; else skeletonLoaderTable">
      <div class="col-md-4">
        <mat-card class="task-table">
          <mat-card-header>
            <h4 class="heading">My Task</h4>
          </mat-card-header>
          <mat-card-content>
            <table class="table" *ngIf="AllContracts.length > 0; else noContract">
               <tbody>
                <tr *ngFor="let contract of AllContracts; let i = index"
                  class="d-flex align-items-center justify-content-between">
                  <td>
                    <p *ngIf="ActiveTileIndication==0">{{columnmessege}} <a href="javascript:void(0)"
                        [routerLink]="['/app/contract','view',contract.contractId]">{{contract.name}}</a> </p>

                    <p *ngIf="ActiveTileIndication==1">{{columnmessege}} <a href="javascript:void(0)"
                        [routerLink]="['/app/contract','view',contract.contractId]">{{contract.name}}</a> </p>

                    <p *ngIf="ActiveTileIndication==2">{{columnmessege}} <a href="javascript:void(0)"
                        [routerLink]="['/app/contract','view',contract.contractId]">{{contract.name}}</a> </p>

                    <p *ngIf="ActiveTileIndication==3">{{columnmessege}} <a href="javascript:void(0)"
                        [routerLink]="['/app/contract','view',contract.contractId]">{{contract.name}}</a> </p>

                    <p *ngIf="ActiveTileIndication==4">{{columnmessege}} <a href="javascript:void(0)"
                        [routerLink]="['/app/contract','view',contract.contractId]">{{contract.name}}</a> </p>

                    <p *ngIf="ActiveTileIndication==5"> <a href="javascript:void(0)"
                        [routerLink]="['/app/contract','view',contract.id]">{{contract.name}}</a>
                      {{columnmessege}} on
                      <strong>{{contract.expiryDate | date}} </strong>
                    </p>

                    <p *ngIf="ActiveTileIndication==6">Contract Worth <strong style="color:red">{{contract.Currency}}
                        {{contract.Amount}}</strong> expire in 30
                      days <a href="javascript:void(0)" [routerLink]="['/app/contract','view',contract.contractId]">
                        {{contract.name}}</a></p>

                    <p *ngIf="ActiveTileIndication==7"><a href="javascript:void(0)"
                      [routerLink]="['/app/contract','view',contract.contractId]">{{contract.contractName}}</a> Worth <strong style="color:red">{{contract.Currency}}
                        {{contract.Amount}}</strong> Pending signatures</p>

                    <p *ngIf="ActiveTileIndication==8">{{columnmessege}} <a href="javascript:void(0)"
                        [routerLink]="['/app/contract','view',contract.contractId]">{{contract.name}}</a> </p>


                  </td>
                  <td>
                    <a (click)="openApproveConfirmation(contract.contractId,contract.name)" class="action">
                      <ng-icon name="heroEye"></ng-icon>
                    </a>
                  </td>

                </tr>
              </tbody>
            </table>
            <ng-template #noContract>
              <div class="not-found px-5 text-center">
                <h4>No Data Found</h4>
                <p>There are no contracts found with
                  <strong [ngSwitch]="ActiveTileIndication">
                    <ng-container *ngSwitchCase="0">
                      Initiated by you
                    </ng-container>
                    <ng-container *ngSwitchCase="1">
                      Pending Signature from you
                    </ng-container>
                    <ng-container *ngSwitchCase="2">
                      Pending Review from you
                    </ng-container>
                    <ng-container *ngSwitchCase="3">
                      Pending Approval from you
                    </ng-container>
                    <ng-container *ngSwitchCase="4">
                      Expiring
                    </ng-container>
                    <ng-container *ngSwitchCase="5">
                      Expired
                    </ng-container>
                    <ng-container *ngSwitchCase="6">
                      Contracts Worth
                    </ng-container>
                    <ng-container *ngSwitchCase="7">
                      Pending Signatures
                    </ng-container>
                    <ng-container *ngSwitchCase="8">
                      Obligation Overdue
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      selected filter
                    </ng-container>
                  </strong>
                </p>
              </div>
            </ng-template>
          </mat-card-content>
        </mat-card>
      </div>

      <div class="col-md-8">
        <mat-card class="graph-section bar-graph">
          <mat-card-header>
            <h4 class="heading">My Contracts </h4>
          </mat-card-header>
          <mat-card-content id="barChart">
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <ng-template #skeletonLoaderTable>
      <div class="row">
        <div class="col-md-4">
          <div class="skeleton-margin">
            <ngx-skeleton-loader [theme]="{height:'60vh'}"></ngx-skeleton-loader>
          </div>
        </div>
        <div class="col-md-8">
          <div class="skeleton-margin">
            <ngx-skeleton-loader [theme]="{height:'60vh'}"></ngx-skeleton-loader>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="skeleton-margin">
            <ngx-skeleton-loader [theme]="{height:'420px'}"></ngx-skeleton-loader>
          </div>
        </div>
        <div class="col-md-6">
          <div class="skeleton-margin">
            <ngx-skeleton-loader [theme]="{height:'420px'}"></ngx-skeleton-loader>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
  <div class="task-graph" *ngIf="!isLoading">
    <app-graph-chart></app-graph-chart>
  </div>
</div>